package one.healthium.base.launcher

actual class PlatformLauncher